import { Alert, Button, Modal } from 'antd';

interface AddLineToCardModalProps {
  open: boolean;
  jobNumber: string;
  error: string | null;
  submitting: boolean;
  onAdd: () => Promise<boolean>;
  onDismiss: () => void;
}

/** Asked once the price is approved: the card was missing this lane, so offer it a line. It only opens a proposal; the card changes when someone else approves it. */
export function AddLineToCardModal({ open, jobNumber, error, submitting, onAdd, onDismiss }: AddLineToCardModalProps) {
  return (
    <Modal
      open={open}
      title="Add this price to the rate card?"
      onCancel={onDismiss}
      footer={[
        <Button key="dismiss" onClick={onDismiss} disabled={submitting}>
          Not now
        </Button>,
        <Button key="add" type="primary" loading={submitting} onClick={() => void onAdd()}>
          Add to rate card
        </Button>,
      ]}
    >
      {error && <Alert className="mb-4" type="error" showIcon title={error} />}
      <p className="mb-0">
        The card had no price for {jobNumber}&apos;s lane. This sends the approved price to the rate card approval queue as a new line, starting tomorrow. The
        card does not change until someone else approves it.
      </p>
    </Modal>
  );
}
